import React, { useState } from 'react';
import { Message } from '@bedrock/components';
import { refundConfirm } from '../../api';
import SendBackModal from '../../SendBackModal';

/**
 * 退款退回弹框 Hook（useSendBackModal 退款适配）
 *
 * 复用面：详情抽屉 / 确认页共用退回弹框（FR-12 退回原因必填）。
 * 结构收敛到共享组件 SendBackModal（合并单笔/批量退回，Alert + Textarea 必填
 * maxLength 200 + width 680，UX 反馈 2026-08-05 底部按钮自适应）。
 * 参照 PrePayment `Drawer/Actions/utils.tsx` useSendBackModal 范式（isRequired:true 走必填校验）。
 */
export const useRefundSendBackModal = ({
  orderId,
  onSuccess,
}: {
  orderId: number | null;
  onSuccess?: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (reason: string) => {
    if (!orderId) return;
    setLoading(true);
    try {
      await refundConfirm({
        refund_order_id: orderId,
        action: 'REJECT',
        reject_reason: reason,
        attachment_ids: undefined,
      });
      Message.success('已退回');
      setVisible(false);
      onSuccess?.();
    } finally {
      setLoading(false);
    }
  };

  const renderModal = () => (
    <SendBackModal
      visible={visible}
      loading={loading}
      onCancel={() => setVisible(false)}
      onConfirm={handleConfirm}
    />
  );

  return {
    open: () => setVisible(true),
    renderModal,
  };
};
